/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";

export default class Switch extends BaseCom {
    render() {
        return (
            <div className="form-group">
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" checked={this.props.checked} onChange={this.props.onChange} disabled={this.props.disabled} />
                    <label className="form-check-label">{this.props.label}</label>
                </div>
            </div>
        );
    }
}